/**
 * O passo Conferir com o cadastro sem espera (E189.F2, ADR-0138).
 *
 * Com o pedido de conclusão `cadastrando`, o caso mostra o círculo, a etapa e a contagem
 * (`CadastrandoOCaso`) e relê; quando o sistema conclui, a conclusão gravada leva ao Acompanhar, como
 * a conclusão da pessoa. Sem pedido, ou com o pedido parado numa decisão, é o Conferir de sempre, com
 * "Precisa da sua conferência" na parada. O "Enviar e seguir" com a leitura em curso deixa a pessoa
 * no caso cadastrando, que vira o recibo com o que faltar quando o sistema conclui (E193.F1.C13,
 * GUS-259 item 1: no GT-2026-0320 ela ia para a lista e não via o que faltava); ela pode sair antes.
 */
import { useCallback } from 'react';

import { ptBR } from '@/i18n/pt-BR';
import { lerConclusao } from '@/lib/conclusao_da_abertura';

import { CadastrandoOCaso } from './CadastrandoOCaso';
import { ConferirEnvio, type ConferirEnvioProps } from './ConferirEnvio';
import { useAndamentoDoCadastro } from './useAndamentoDoCadastro';

export interface ConferirOuCadastrandoProps extends Omit<
  ConferirEnvioProps,
  'parada' | 'onEnviado'
> {
  onVoltarAosCasos: () => void;
  onNovoCaso: () => void;
}

export function ConferirOuCadastrando(props: ConferirOuCadastrandoProps): JSX.Element {
  const { client, caseId, onConcluido, onVoltarAosCasos, onNovoCaso, ...conferir } = props;
  const concluidoPeloSistema = useCallback(() => {
    void lerConclusao(client, caseId)
      .then((conclusao) => {
        if (conclusao !== null) onConcluido(conclusao);
      })
      .catch(() => undefined);
  }, [client, caseId, onConcluido]);
  const { andamento, recarregar } = useAndamentoDoCadastro(client, caseId, concluidoPeloSistema);

  if (andamento === undefined) {
    return <p className="text-body-sm text-fg-muted">{ptBR.abertura.conferirEnvio.carregando}</p>;
  }
  if (andamento?.situacao === 'cadastrando') {
    return (
      <CadastrandoOCaso
        andamento={andamento}
        onVoltarAosCasos={onVoltarAosCasos}
        onNovoCaso={onNovoCaso}
      />
    );
  }
  return (
    <ConferirEnvio
      {...conferir}
      client={client}
      caseId={caseId}
      onConcluido={onConcluido}
      parada={andamento?.motivo ?? null}
      onEnviado={recarregar}
    />
  );
}
